import { useMemo } from 'react'

import { useAccountReadContext } from '@context/AccountContextContext'

import { isSumsubNeeded } from '@utils/AccountAccess/accountKYCStatuses'

export const useDocumentVerificationPath = (): string => {
  const { account } = useAccountReadContext()

  return useMemo(() => {
    if (!account) {
      return '/profile/document-management'
    }
    if (isSumsubNeeded(account)) {
      return '/profile/verification'
    } else {
      return '/profile/document-management'
    }
  }, [account])
}
